/**
 * @generated SignedSource<<ebb0b7e6642a36eeff856e78db0dd18b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CelebrationViewPageQuery$variables = {
  sessionId: string;
};
export type CelebrationViewPageQuery$data = {
  readonly session: {
    readonly scrapbookPage: {
      readonly id: string;
      readonly sticker: string;
    } | null | undefined;
  } | null | undefined;
};
export type CelebrationViewPageQuery = {
  response: CelebrationViewPageQuery$data;
  variables: CelebrationViewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "sessionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ScrapbookPage",
  "kind": "LinkedField",
  "name": "scrapbookPage",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sticker",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CelebrationViewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CelebrationViewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21c8149496781cef86402b55a4955ed5",
    "id": null,
    "metadata": {},
    "name": "CelebrationViewPageQuery",
    "operationKind": "query",
    "text": "query CelebrationViewPageQuery(\n  $sessionId: ID!\n) {\n  session(id: $sessionId) {\n    scrapbookPage {\n      id\n      sticker\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8e5accae66f80867f37c339c10c40c9";

export default node;
